export interface KeyedItem<T> {
  item: T;
  key: string;
  id: string; // WSR <Table /> expects this specific property, not configurable
  pageIndex: number;
  indexWithinPage: number;
  index: number;
}
